<div class="app-wrapper" *ngIf="access; else noAccessForm" [ngClass]="{'with-overlay': modalView != VIEW_MODAL_NONE || leavingModal}">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section forms-main-content">
        <core-layout-modal-feedback class="modal-feedback" *ngIf="leavingModal"
            [type]="'warning'"
            [message]="'Discard Form Changes'"
            [text]="'You have not saved your form and fields yet. Are you sure you want to leave and discard your form draft?'"
            [buttonText]="'Discard'"
            [secondButtonText]="'Go Back'"
            (action)="onDiscard($event)"
            (secondButtonAction)="onStay($event)"
        ></core-layout-modal-feedback>
        <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView === VIEW_MODAL_FORBIDDEN"
            [type]="'fail'"
            [message]="'Error'"
            [text]="'You do not have access to save this form.<br/> If the error persists, please reach out to our support team through the Help Me button.'"
            [buttonText]="'OK'"
            (action)="onError($event)">
        </core-layout-modal-feedback>
        <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView === VIEW_MODAL_ERROR"
            [type]="'fail'"
            [message]="'Error'"
            [text]="'This form could NOT be updated. Please contact your admin for additional support.'"
            [buttonText]="'OK'"
            (action)="onError($event)">
        </core-layout-modal-feedback>
        <core-layout-modal-feedback *ngIf="modalView === VIEW_MODAL_DATA_ERROR"
            [type]="'warning'"
            [message]="'Form not saved'"
            [text]="'The data in the form editor is not correct. Review your form data and try again in a moment.'"
            [buttonText]="'OK'"
            (action)="onError($event)">
        </core-layout-modal-feedback>
        <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView === VIEW_MODAL_FIELD_OVERWRITE_WARNING"
            [type]="'warning'"
            [message]="'Warning'"
            [text]="'When you modify a template form, the already stored data will be affected. Please proceed with caution.'"
            [buttonText]="'OK'"
            [secondButtonText]="'Cancel'"
            (action)="onSubmit()"
            (secondButtonAction)="onOverwriteDismiss()">
        </core-layout-modal-feedback>
        <div class="app-main">
            <header>
                <div class="data-header">
                  <core-title-section
                    [title]="titleText"
                    [description]="'Here you can configure the fields of your project.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                </div>
            </header>
            <div class="loader" [hidden]="status == STATUS_DONE">
                <div class="dimmed">
                    <div class="dimmed_table_box dimmed_table_padding">
                        <header>
                            <div class="dimmed_flex">
                                <div class="dimmed_title"></div>
                            </div>
                        </header>
                        <div class="dimmed_data">
                            <div class="dimmed_subtitle"></div>
                            <div class="dimmed_title"></div>
                        </div>
                    </div>
                </div>
            </div>
            
           
            <div class="forms-add" *ngIf="status == STATUS_DONE">
                <settings-forms-form-main
                    [currentForm]="editingForm"
                    (cancel)="cancel($event)"
                    (submit)="onPreSubmit($event)"
                ></settings-forms-form-main>
            </div>
        </div>
    </section>
</div>

<ng-template #noAccessForm>
    <core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
</ng-template>
